module.exports = __webpack_public_path__ + "img/blockAB33.e2687f66.svg";